type IsControlLinked = (params: {
  controlId: string;
  linkedControlIds: string[];
  linkedFrameworkControlIdentifiers: string[];
  control_identifier?: string | null;
}) => boolean;

export const isControlLinked: IsControlLinked = ({
  controlId,
  linkedControlIds,
  linkedFrameworkControlIdentifiers,
  control_identifier,
}) => {
  if (linkedControlIds.includes(controlId)) {
    return true;
  }

  if (control_identifier && linkedFrameworkControlIdentifiers.includes(control_identifier)) {
    return true;
  }

  return linkedFrameworkControlIdentifiers.includes(controlId);
};
